import { INSIGHT_RULES } from '../../data/insightRulesData';

/**
 * Evaluate all insight rules against current state + derived values.
 * Returns matched rules sorted by priority (1 = highest).
 */
export function evaluateInsights(state, derived) {
  return INSIGHT_RULES
    .filter((rule) => {
      try {
        return rule.condition(state, derived);
      } catch {
        return false;
      }
    })
    .sort((a, b) => a.priority - b.priority);
}
